<template>
  <v-layout xs12 sm12 row justify-center>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title>{{ $t('toolbar_title')}}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-toolbar-items>
            <v-btn dark flat @click.native="save">{{ $t('save')}}</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 v-if="configuration.auditname">
                <v-text-field v-model="editedItem.name" label="Template Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="configuration.standard">
                <v-autocomplete
                  :items="currentStandards"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.standard"
                  label="Standards"
                  persistent-hint
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="configuration.type">
                <v-autocomplete
                  :items="currentTypes"
                  v-model="editedItem.type"
                  label="Audit Art"
                  hint="Was ist das für eine Audit-Art?"
                  persistent-hint
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="configuration.audited_by">
                <v-autocomplete
                  :items="currentAuditedBy"
                  v-model="editedItem.audited_by"
                  label="Interessierte Parteien"
                  hint
                  persistent-hint
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field readonly label="Angelegt durch" v-model="editedItem.created_by"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="configuration.scope">
                <v-autocomplete
                  :items="currentScopes"
                  v-model="editedItem.scope"
                  label="Bereiche"
                  multiple
                  chips
                  hint="What are the target regions"
                  persistent-hint
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="configuration.process">
                <v-autocomplete
                  :items="currentProcesses"
                  v-model="editedItem.process"
                  label="Prozesse"
                  multiple
                  chips
                  hint="Zugehörige Prozesse"
                  persistent-hint
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="configuration.tags">
                <auto-complete></auto-complete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <MenuDatePicker
                  label="Template angelegt am"
                  v-model="editedItem.created_date"
                  clearable
                />
              </v-flex>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">{{ $t('cancel')}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save">{{ $t('save')}}</v-btn>
              </v-card-actions>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
{
  "de": {
    "toolbar_title": "Audit Metadaten",
    "protect_label": "Audit schützen",
    "unprotect_label": "Audit geschützt",
    "auditname_label": "Audit Name",
    "standard_label": "Auditerter Standard",
    "process_label": "Auditerter Prozess",
    "audittype_label": "Audit Art",
    "interestedparties_label": "Interessierte Parteien",
    "auditedby_label": "Audit Typ",
    "auditscope_label": "Auditierter Bereich",
    "auditor_label": "Auditoren",
    "auditparticipants_label": "Audit Teilnehmer",
    "responsible_label": "Verantwortlich für die Maßnahmen",
    "planning_date_label": "Datum der Planung",
    "auditing_date_label": "Datum der Durchführung",
    "status_label": "Status im Auditprozess",
    "save": "Speichern",
    "cancel": "Abbrechen"
  },
  "en": {
    "auditfinding_title": "Audit Finding",
    "auditfinding_label": "Description of the Finding"  
  }
}
</i18n>

<script>
// Controls/Snippets
import AutoComplete from "@/components/controls/AutoComplete.vue";
import MenuDatePicker from "@/components/controls/MenuDatePicker";

import { mapActions, mapGetters } from "vuex";
import { api } from "@/store/modules/templates";
import { api as userApi } from "@/store/modules/users";
import { api as confApi } from "@/store/modules/configuration";
import { api as standardApi } from "@/store/modules/standards";

import uuid from "uuid";

export default {
  props: {
    dialog: {
      default: true
    }
  },
  components: {
    AutoComplete,
    MenuDatePicker
  },
  data() {
    return {
      modal1: false,
      modal2: false
    };
  },
  computed: {
    ...mapGetters(confApi.namespace, [confApi.getters.audit]),
    ...mapGetters(api.namespace, [
      api.getters.getDialogItem,
      api.getters.getDialogAction
    ]),
    ...mapGetters(userApi.namespace, [
      userApi.getters.getLoadedUsersByRole,
      userApi.getters.user
    ]),
    ...mapGetters(standardApi.namespace, [standardApi.getters.getStandardList]),
    configuration() {
      return this.audit.dialog || {};
    },
    editedItem() {
      return this.getDialogItem;
    },
    isUpdate() {
      if (this.getDialogAction === "update") {
        return true;
      } else {
        return false;
      }
    },
    created_by() {
      // TODO: ID auflösen?
      return this.$user.displayName();
    },
    currentScopes() {
      return this.audit.data.scopes;
    },
    currentStatus() {
      return this.audit.data.status;
    },
    currentTypes() {
      return this.audit.data.types;
    },
    currentStandards() {
      console.log("StandardList", this.getStandardList);
      return this.getStandardList;
    },
    currentProcesses() {
      return this.audit.data.processes;
    },
    currentAuditedBy() {
      return this.audit.data.auditparties;
    },
    currentAuditors() {
      return this.getLoadedUsersByRole("auditor");
    },
    currentUsers() {
      return this.getLoadedUsers;
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.createAudit,
      api.actions.updateAudit
    ]),
    close() {
      this.$emit("update:dialog", false);
    },
    save() {
      if (this.isUpdate) {
        const payload = {
          audit_id: this.editedItem.id,
          data: this.editedItem,
          activity: {
            id: uuid.v4(),
            avatar: this.$user.avatar(),
            actor: this.$user.id(),
            actor_name: this.$user.displayName(),
            verb:
              this.$user.displayName() +
              " hat das Template " +
              this.editedItem.name +
              " bearbeitet",
            object: this.editedItem.id,
            object_url: "/templates/" + this.editedItem.id,
            timestamp: new Date().toISOString().slice(0, 10)
          }
        };

        this.$store.dispatch("templates/updateAudit", payload);
      } else {
        const payload = {
          audit_id: this.editedItem.id,
          data: this.editedItem,
          activity: {
            id: uuid.v4(),
            avatar: this.$user.avatar(),
            actor: this.$user.id(),
            actor_name: this.$user.displayName(),
            verb:
              this.$user.displayName() +
              " hat das Template " +
              this.editedItem.name +
              " angelegt",
            object: this.editedItem.id,
            object_url: "/templates/" + this.editedItem.id,
            timestamp: new Date().toISOString().slice(0, 10)
          }
        };

        this.$store.dispatch("templates/createAudit", payload);
      }
      this.close();
    }
  }
};
</script>
